import {
  Users, Handshake, Fingerprint, CalendarClock, CalendarDays, FileText, MapPin, Wrench, Route, BarChart3, Receipt, ShoppingCart, Settings2,
  Landmark, UserCheck, Wallet, Target, BellRing, FilePlus2, AlertCircle,
} from "lucide-react";

export const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const soon = (label) => ({ label, path: `/coming-soon/${slugify(label)}`, soon: true });
const item = (label, path) => ({ label, path });

const mine = (label, path) => ({ label, path, self: true });

export const MENU = [
  {
    group: "My Workspace", icon: UserCheck,
    items: [mine("My Attendance", "/me/attendance"), mine("My Leave", "/me/leave"), mine("My Regularizations", "/me/regularizations"), mine("Pending my action", "/me/approvals"), mine("My Payslips", "/me/payslips"), mine("My Target", "/me/target")],
  },
  {
    group: "Payroll", icon: Wallet,
    items: [item("Pay Runs", "/payroll/runs"), item("Salary Structures", "/payroll/structures"), item("Payroll Settings", "/payroll/settings")],
  },
  {
    group: "Sales Targets", icon: Target,
    items: [item("Targets & Leaderboard", "/targets")],
  },
  {
    group: "Alerts", icon: BellRing,
    items: [item("Alert Settings", "/alerts/settings")],
  },
  {
    group: "Employee Management", icon: Users,
    items: [
      item("View All Employees", "/employees"),
      item("Add New Employee", "/employees/new"),
      item("Organization Setup", "/organization"),
      soon("Invite Employees"),
      soon("Employee Registration Requests"),
    ],
  },
  {
    group: "Employee Punches", icon: Fingerprint,
    items: [
      item("Employee Punches", "/punches"),
      item("Who's In", "/whos-in"),
      item("Mobile Checkin Report", "/reports/mobile-checkin"),
      item("Punch Settings", "/punches/settings"),
    ],
  },
  {
    group: "Attendance & Shift Management", icon: CalendarClock,
    items: [
      item("Attendance Records", "/attendance/records"), item("Regularization Requests", "/attendance/regularizations"),
      item("Attendance Summary Report", "/attendance/summary"), item("Manual OT / HOT", "/attendance/ot"),
      item("Shift Settings", "/attendance/settings"), item("Work Week Settings", "/attendance/settings?tab=work-week"),
    ],
  },
  {
    group: "Leave Management", icon: CalendarDays,
    items: [
      item("Leave Requests", "/leave/requests"), item("Assign Leave", "/leave/assign"), item("Holidays", "/leave/holidays"),
      item("Leave Entitlements", "/leave/entitlements"), item("Leave Balance History", "/leave/history"),
      item("Entitlement & Usage Report", "/leave/report"), item("Leave Settings", "/leave/settings"),
    ],
  },
  {
    group: "Employee Documents", icon: FileText,
    items: [
      item("Manage Personal Documents", "/documents/personal"),
      item("Manage Dependants Documents", "/documents/dependants"),
      item("Document Settings", "/documents/settings"),
    ],
  },
  {
    group: "CRM", icon: Handshake,
    items: [
      item("CRM Dashboard", "/crm"),
      item("Leads", "/crm/leads"),
      item("Pipeline", "/crm/pipeline"),
      item("Follow-ups", "/crm/follow-ups"),
      item("Customers", "/crm/customers"),
      item("All Parties", "/parties"),
      { ...item("Connections", "/parties/connections"), admin: true },
      item("CRM Settings", "/crm/settings"),
      item("Lead Capture", "/crm/settings/lead-capture"),
    ],
  },
  {
    group: "Sales & Billing", icon: Receipt,
    items: [
      item("Order Requests", "/billing/order-requests"),
      item("Quotations", "/billing/quotations"),
      item("Invoices", "/billing/invoices"),
      item("Credit Notes", "/billing/credit-notes"),
      item("Payments", "/billing/payments"),
      item("Outstanding", "/billing/outstanding"),
      item("Credit Control", "/billing/credit-control"),
      item("Products & Services", "/billing/products"),
      item("Billing Settings", "/billing/settings"),
    ],
  },
  {
    group: "Purchases & Expenses", icon: ShoppingCart,
    items: [
      item("Vendors", "/purchases/vendors"),
      item("Purchase Orders", "/purchases/orders"),
      item("Vendor Order Book", "/purchases/order-book"),
      item("Reorder", "/purchases/reorder"),
      item("Vendor Bill Inbox", "/purchases/bill-inbox"),
      item("Purchase Invoices", "/purchases/invoices"),
      item("Debit Notes / Returns", "/purchases/debit-notes"),
      item("Payment Out", "/purchases/payments-out"),
      item("Expenses", "/purchases/expenses"),
      item("Party to Party Transfer", "/purchases/transfers"),
      item("Stock", "/purchases/stock"),
      item("Party Ledger", "/purchases/ledger"),
    ],
  },
  {
    group: "Accounting", icon: Landmark,
    items: [
      item("Chart of Accounts", "/accounting/accounts"),
      item("New Voucher (JV / Contra)", "/accounting/vouchers/new"),
      item("Day Book", "/accounting/day-book"),
      item("Cash Book", "/accounting/cash-book"),
      item("Bank Book", "/accounting/bank-book"),
      item("Account Ledger", "/accounting/ledger"),
      item("Trial Balance", "/accounting/trial-balance"),
      item("Profit & Loss", "/accounting/profit-loss"),
      item("Balance Sheet", "/accounting/balance-sheet"),
      item("GSTR-1", "/accounting/gstr1"),
      item("GSTR-3B", "/accounting/gstr3b"),
      item("Accounting Settings", "/accounting/settings"),
    ],
  },
  {
    group: "Locations Management", icon: MapPin,
    items: [
      item("View All Locations", "/locations"),
      item("Add New Location", "/locations/new"),
      item("Manage Location Categories", "/locations/categories"),
    ],
  },
  {
    group: "Settings", icon: Settings2,
    items: [item("Business Profile", "/settings/business-profile"), item("Import Center", "/settings/imports"), item("My plan", "/settings/my-plan"), item("Access Roles", "/settings/roles")],
  },
  {
    group: "Tools", icon: Wrench,
    items: [soon("Announcements"), soon("Approval Forward Settings")],
  },
  {
    group: "Field Journey Tracker", icon: Route,
    items: [soon("Summary View"), soon("Map View")],
  },
  {
    group: "Reports", icon: BarChart3,
    items: [
      soon("Punch Report"), soon("Attendance Report"), soon("Leave Report"), soon("Geofence Report"),
      soon("Journey Report"), soon("Employee Report"), soon("Audit Report"), soon("Custom Report"),
    ],
  },
];

// Phase 15: sidebar sections and per-focus layout (order, emphasis, default expansion, pinned items) in one map.
export const SECTIONS = {
  finance: { label: "Finance", groups: ["Sales & Billing", "Accounting", "Purchases & Expenses"] },
  sales_crm: { label: "Sales & CRM", groups: ["CRM"] },
  people: { label: "People & HR", groups: ["My Workspace", "Payroll", "Employee Management", "Employee Punches", "Attendance & Shift Management", "Leave Management", "Employee Documents", "Locations Management", "Sales Targets", "Alerts"] },
  admin: { label: "Admin", groups: ["Settings", "Tools", "Field Journey Tracker", "Reports"] },
};
const PIN = {
  newInvoice: { label: "New Invoice", path: "/billing/invoices/new", need: "create", icon: FilePlus2 },
  outstanding: { label: "Outstanding", path: "/billing/outstanding", icon: AlertCircle },
  whosIn: { label: "Who's In", path: "/whos-in", icon: Fingerprint },
  leaveRequests: { label: "Leave Requests", path: "/leave/requests", icon: CalendarDays },
};
export const FOCUS = {
  finance: { title: "Business overview", order: ["finance", "sales_crm", "people", "admin"], strong: ["finance"], muted: ["people"], closed: ["people"],
    open: ["Sales & Billing", "Accounting"], pinned: [PIN.newInvoice, PIN.outstanding] },
  hr: { title: "Team overview", order: ["people", "finance", "sales_crm", "admin"], strong: ["people"], muted: ["finance"], closed: ["finance"],
    open: ["My Workspace", "Employee Punches", "Attendance & Shift Management", "Leave Management"], pinned: [PIN.whosIn, PIN.leaveRequests] },
  balanced: { title: "Business overview", order: ["finance", "sales_crm", "people", "admin"], strong: [], muted: [], closed: ["sales_crm", "people", "admin"],
    open: ["Sales & Billing", "Accounting"], pinned: [PIN.newInvoice, PIN.whosIn] },
};
export const FOCUS_LABELS = { finance: "Finance & Billing", hr: "HR & Attendance", balanced: "Both" };
export const focusOf = (user) => (FOCUS[user?.business_focus] ? user.business_focus : "finance");

export function findMenuItem(path) {
  for (const g of MENU) {
    const it = g.items.find((i) => i.path === path);
    if (it) return { ...it, group: g.group, icon: g.icon };
  }
  return null;
}

const MOD = [["/payroll", "payroll"], ["/targets", "targets"], ["/alerts", "alerts"], ["/attendance", "attendance"], ["/leave", "leave"], ["/employees", "hr"], ["/organization", "hr"], ["/documents", "hr"], ["/locations", "hr"], ["/punches/settings", "punches"],
  ["/punches", "punches"], ["/whos-in", "punches"], ["/reports/mobile-checkin", "punches"], ["/crm/settings/lead-capture", "lead_capture"],
  ["/crm/settings", "settings"], ["/crm", "crm"], ["/billing/order-requests", "quotations"], ["/billing/quotations", "quotations"],
  ["/billing/invoices", "invoices"], ["/billing/credit-notes", "invoices"], ["/billing/outstanding", "invoices"], ["/billing/credit-control", "credit"], ["/accounting", "accounting"], ["/parties", "parties"], ["/billing/payments", "payments"],
  ["/billing/products", "stock"], ["/billing/settings", "settings"], ["/purchases/expenses", "expenses"], ["/purchases/order-book", "order_book"], ["/purchases/reorder", "order_book"], ["/purchases/stock", "stock"],
  ["/purchases", "purchases"], ["/settings/imports", "accounting"], ["/settings", "settings"]];
export const moduleOf = (path) => MOD.find(([p]) => path === p || path.startsWith(`${p}/`))?.[1];
export const canCreate = (user, path) => user.is_admin || (!!moduleOf(path) && !!user.permissions?.[moduleOf(path)]?.create);
export const canView = (user, path) => user.is_admin || (!!moduleOf(path) && !!user.permissions?.[moduleOf(path)]?.view);
